import emojiRegex from 'emoji-regex'

export const EMOJI_REGEX = emojiRegex()
